import AssessmentOutlined from '@mui/icons-material/AssessmentOutlined';
import LanguageOutlined from '@mui/icons-material/LanguageOutlined';
import ListOutlined from '@mui/icons-material/ListOutlined';
import { IconMailSearch } from 'components/icons';
// third-party
import { FormattedMessage } from 'react-intl';

// assets

import { NavItemType } from 'types';

const history: NavItemType = {
    id: 'history',
    title: <FormattedMessage id="HISTORIAL" />,
    icon: LanguageOutlined,
    type: 'group',
    children: [
        {
            id: 'history-operations',
            title: 'OPERACIONES',
            type: 'item',
            url: '/history-operations',
            icon: ListOutlined
        },
        {
            id: 'history-communications',
            title: 'COMUNICACIONES',
            type: 'item',
            url: '/history-communications',
            icon: IconMailSearch
        },
        {
            id: 'history-reports',
            title: 'INFORMES',
            type: 'item',
            url: '/history-reports',
            icon: AssessmentOutlined
        }
    ]
};

export default history;
